import React, { useContext, useEffect } from 'react';

import AlertBasic from '../alert-basic';
import { ALERT_TYPES } from '../../alert-types';
import colors from '../../../../utils/colors';
import { FormContext } from '../../../../contexts/generated-content/content-form-context';

interface Props {
	isLocked: boolean;
}

export default function StylepackNoContentAlert(props: Props) {
	const {hasText} = useContext(FormContext);

	return (hasText || props.isLocked) ? null : <>
		<AlertBasic 
			alert={{
				message: 'Copy needed',
				description: 'Provide input to update the lower third.',
				type: ALERT_TYPES.ERROR
			}}
			alertStyle={{
				backgroundColor: colors.blGrayscale800,
				minWidth: '100%',
			}}
			containerStyle={{
				padding: '0 0 0 24px',
				position: 'absolute',
				bottom: 0,
				left: '7px',
				right: 0,
				pointerEvents: 'none',
				minWidth: '100%'
			}}
		/>
	</>
}
